module.exports = function () {

    if ($('.embedded-events').length) {
        var sortElements = function ($grid, pastEvents) {
            $grid.find('.events-grid-event').sort(function (a, b) {
                if ($(a).data('pastEvent')) {
                    if ($(b).data('pastEvent')) {
                        return $(a).data('index') > $(b).data('index');
                    } else {
                        return pastEvents ? -1 : 1;
                    }
                }
                else if ($(b).data('pastEvent')) {
                    return pastEvents ? 1 : -1;
                } else {
                    return $(a).data('index') > $(b).data('index');
                }

            }).appendTo($grid);
        };

        $('.embedded-events .events-time-header-option').click(function () {
            var $container = $(this).closest('.embedded-events');
            $container.find('.events-time-header-option-active').removeClass('events-time-header-option-active');
            $(this).addClass('events-time-header-option-active');

            if ($(this).data('value')) {
                $container.find('.events-grid-event[data-past-event=true]').show();
                $container.find('.events-grid-event[data-past-event=false]').hide();
            } else {
                $container.find('.events-grid-event[data-past-event=true]').hide();
                $container.find('.events-grid-event[data-past-event=false]').show();
            }

            sortElements($container.find('.events-grid'), $(this).data('value'));

            return false;
        });

        $('.embedded-events').each(function() {
            sortElements($(this).find('.events-grid'), false);
        });
    }
};